import { createFileRoute } from "@tanstack/react-router";

import { BusinessSettingsPage } from "../../../features/settings/business-settings-page";

export const Route = createFileRoute("/_app/settings/business")({ component: BusinessSettingsPage });
